const LyocBlurb = () => {
	return (
		<div className="blurb-form">
			<p>
				LAST YEAR OF CARBON is a cooperative and competitive strategy
				boardgame.
				<br />
				<br />
				Each player acts as a renewable energy company in a world
				running on the last drops of non-renewable fuel (gas, coal,
				etc.).
				<br />
				<br />
				You must work together to power the planet, while simultaneously
				building up your infrastructure and convincing the public that
				you (and only you) are the best company to replace carbon based
				fuels.
				<br />
				<br />
				Do you have what it takes to survive & thrive during the Last
				Year Of Carbon?
				<br />
				<br />
				This online version of the physical board game is free to play.
				Enjoy!
			</p>
			<p style={{ textAlign: 'right' }}>- Nick aka Commas ( ,____ʌ, )</p>
		</div>
	);
};

export default LyocBlurb;
